import React from "react";
import IncompleteRequestsDashboard from "../components/requests/IncompleteRequestsDashboard";

export default function IncompleteRequestsPage() {
  return <IncompleteRequestsDashboard scope="all" />;
}
